import { type ReactNode } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { type TeamNavigationConfig } from '../jsm-portal-playground-data';

import { JsmPlaygroundNavigation } from './jsm-playground-navigation';

export type JsmPlaygroundScreenProps = {
	config: TeamNavigationConfig;
	teamName: string;
	children?: ReactNode;
};

/**
 * A product screen inside the preview card: the shared JSM top navigation over a content column
 * that fills the rest of the fixed 750px stage.
 *
 * The column never scrolls. Anything taller than the stage is clipped at the card's edge, so a
 * screen that needs scrolling has to own it on the specific region that scrolls.
 */
export const JsmPlaygroundScreen = ({ config, teamName, children }: JsmPlaygroundScreenProps) => (
	<div css={screenStyles}>
		<JsmPlaygroundNavigation config={config} teamName={teamName} />
		<div css={contentStyles}>{children}</div>
	</div>
);

const screenStyles = css({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	height: '100%',
	minHeight: 0,
	borderRadius: token('radius.xlarge'),
	backgroundColor: token('elevation.surface'),
	overflow: 'hidden',
});

const contentStyles = css({
	display: 'flex',
	flexDirection: 'column',
	flex: '1 1 auto',
	minHeight: 0,
	minWidth: 0,
	overflow: 'hidden',
});
